const handleNumericCheck = (
  event,
  allowfloat = "",
  maxFloat,
  allowNegative = false,
  maxLength = 20
) => {
  const { value } = event.target;
  const regex = new RegExp(`^-?\\d{1,${maxLength}}(\\.\\d{0,${maxFloat}})?$`);
  var charCode = event.which ? event.which : event.keyCode;
  // debugger;
  if (charCode === 46) {
    // Check if event.target.value already contains the . character
    if (event.target.value.indexOf(".") === -1) {
      if (allowfloat === "allowFloat") {
        return true;
      }
      event.preventDefault();
      return false;
    } else {
      event.preventDefault();
      return false;
    }
  } else if (charCode === 45) {
    // Allow negative sign (-) if it's not already present or if the cursor is at the beginning

    if (
      allowNegative &&
      value.indexOf("-") === -1 &&
      event.target.selectionStart === 0
    ) {
      return true;
    }
    event.preventDefault();
    return false;
  } else {
    if (charCode >= 48 && charCode <= 57) {
      if (maxFloat) {
        if (document.getSelection().toString().length > 0) {
          return true;
        } else {
          if (regex.test(value) || value === "-" || value === "") {
            return true;
          } else {
            event.preventDefault();
            return false;
          }
        }
      } else {
        return true;
      }
    } else {
      event.preventDefault();
      return false;
    }
  }
};

export default handleNumericCheck;
